
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../../components/general/ProgressComponent";
import {
    BASE_URL,
    GET_STAFF_LOGS,
} from "../../../env";
import {
    getRecords,
    isSuccess,
    catchAsync,
} from "../../../helper/helper";
import moment from "moment";
function UserLogs() {
    const [userData, setUserData] = useState([]);
    const apiQuery = {
        skip: 0,
        limit: 10,
    };

    const [search, setSearch] = useState("");
    const [filterSearch, setFilterSearch] = useState();
    const [isLoading, setIsLoading] = useState(true);


    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const actionRecentIncidentsData = data?.data?.staffLogs
            const userLogListsData = actionRecentIncidentsData?.map((item) => item);
            setUserData(userLogListsData);
            setFilterSearch(userLogListsData);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const query = req ? req : apiQuery
        const response = await getRecords(GET_STAFF_LOGS, query);
        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {

        if (!isLoading) {
            const apiQuery = {
                skip: 0,
                limit: 10000,
            };
            fetchAllRecords(apiQuery)
        }
    }, [isLoading]);

    // Table Columns
    const columns = [
        {
            name: "Staff Member",
            selector: (row) => {
                return (
                    <>
                        <span className="usersNameInfo m-2 ml-0">
                            <span className="userImage mr-3">
                                <img src={BASE_URL + row?.staffId?.user?.profile_picture_url} />
                            </span>
                            <span className="userInfo">
                                <span className="nameBlock">{row?.staffId?.staffMemberName}</span>
                                <span className="nameBlock capitalizeTransform"><small>{row?.staffId?.staffDesignation}</small></span>
                            </span>
                        </span>
                    </>
                );
            },
        },
        {
            name: "Last Login",
            selector: (row) => {
                return (
                    <div className="pt-3 pb-3">
                        <p className="m-0">
                            {moment(row?.loginTime).format("DD/MM/YYYY")}
                            <small className="m-0">{moment(row?.loginTime).format("hh:mm:ss A")}</small>
                        </p>
                    </div>
                );
            },
        },
        {
            name: "Device ID",
            selector: (row) => (
                <p className="m-0">
                    {row?.deviceId}
                </p>
            ),
        },
        {
            name: "Device Name",
            selector: (row) => (
                <p className="m-0">
                    {row?.deviceName}
                </p>
            ),
        },
    ];


    // Search Filter
    useEffect(() => {
        const result = userData.filter((user) => {
            const filterStaffMemberName = user?.staffId?.staffMemberName
            return filterStaffMemberName.toLowerCase().match(search.toLowerCase());
        });
        setFilterSearch(result);
    }, [search, userData]);



    return (
        <>
            <div className="mainContent pbsPlan">
                <div className="dataTableWrapper">
                    <DataTable
                        className="maxWidthTable"
                        columns={columns}
                        data={filterSearch}
                        pagination
                        paginationRowsPerPageOptions={[1, 25, 50, 100]}
                        paginationPerPage={10}
                        fixedHeader
                        fixedHeaderScrollHeight="520px"
                        highlightOnHover
                        responsive={true}
                        subHeader={true}
                        subHeaderComponent={
                            <div className="searchContainer">
                                <div className="searchTextBox">
                                    <input
                                        type="text"
                                        placeholder="Search by Staff Member"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        }
                        subHeaderAlign="left"
                        subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                        progressPending={isLoading}
                        progressComponent={<ProgressComponent />}
                    />
                </div>
            </div>
        </>
    );
}

export default UserLogs